import { useNotification } from "components/Notification/useAddNotification";
import { useContextConsumer } from "../../context/Providers/ContextProvider";

export const useEditAppointmentNotification = () => {
  const { addNotification } = useNotification();
  const { validityLinkAppointmentTime } = useContextConsumer();
  const notificationTitle = "Zmiana terminu";

  const showSuccessNotification = () =>
    addNotification({
      title: notificationTitle,
      description: `Rezerwacja wymaga potwierdzenia. Na wskazany adres email została wysłana wiadomość z linkiem aktywacyjnym. Proszę o potwierdzenie rezerwacji w ciągu ${validityLinkAppointmentTime} minut.`,
      type: "success",
    });

  const showErrorNotification = (errorMsg?: string) =>
    addNotification({
      title: notificationTitle,
      description: errorMsg || "Nie udało się edytować wizyty",
      type: "error",
    });

  return { showSuccessNotification, showErrorNotification };
};
